// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator timeoff`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'
import features from 'modules/core/store/collections/features'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companyHolidays, {}] /* Referenced by 24 cases in this module */,
    [features, {}] /* Referenced by 66 cases in this module */,
  ] /* Generated file 👉 artifacts/timeoff-module-calendar_teams.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
